// Shared helpers for legal pages (Terms, Privacy, Creator Terms).
// Supports two inline markers in every string:
//   **bold**            -> <strong>
//   [label](url)        -> <a> (mailto:, http(s), or /internal path)

import React from "react";

export const LEGAL_LANGS = [
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
  { code: "de", label: "DE" },
];

export const BACK_LABEL = {
  it: "Indietro",
  en: "Back",
  es: "Atrás",
  fr: "Retour",
  de: "Zurück",
};

const INLINE_RE = /(\*\*[^*]+\*\*)|(\[[^\]]+]\([^)]+\))/g;

export function renderInline(text) {
  if (text == null) return null;
  const parts = [];
  let last = 0;
  let key = 0;
  let m;
  INLINE_RE.lastIndex = 0;
  while ((m = INLINE_RE.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const tok = m[0];
    if (tok.startsWith("**")) {
      parts.push(<strong key={`b${key++}`}>{tok.slice(2, -2)}</strong>);
    } else {
      const linkMatch = tok.match(/^\[([^\]]+)]\(([^)]+)\)$/);
      const label = linkMatch[1];
      const url = linkMatch[2];
      const isExternal = /^https?:\/\//i.test(url);
      parts.push(
        <a
          key={`a${key++}`}
          href={url}
          className="text-blue-600 underline"
          {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        >
          {label}
        </a>
      );
    }
    last = m.index + tok.length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

// Renders a document with the same shape used by termsContent / privacyContent /
// creatorTermsContent: { title, version, sections: [{ h, p?, ul?, p2? }] }
export function LegalSections({ sections }) {
  return (
    <div className="prose prose-sm text-gray-700 space-y-6">
      {sections.map((s, i) => (
        <section key={i}>
          <h2 className="text-lg font-semibold text-gray-900">{s.h}</h2>
          {(s.p || []).map((p, j) => (
            <p key={`p${j}`}>{renderInline(p)}</p>
          ))}
          {s.ul && (
            <ul className="list-disc pl-5 space-y-1 mt-2">
              {s.ul.map((li, k) => (
                <li key={`li${k}`}>{renderInline(li)}</li>
              ))}
            </ul>
          )}
          {(s.p2 || []).map((p, j) => (
            <p key={`p2${j}`} className="mt-2">
              {renderInline(p)}
            </p>
          ))}
        </section>
      ))}
    </div>
  );
}
